import { Module } from 'vuex';

import { invoicesService } from '@/services/invoices/invoices.service';
import { Invoice } from '@/services/invoices/invoices.types';
import { RootState } from '@/store';

export interface InvoiceState {
  invoice: Invoice;
  invoiceLoading: boolean;
  downloadLoading: boolean;
}

const state: InvoiceState = {
  invoice: null,
  invoiceLoading: false,
  downloadLoading: false
};

const options: Module<InvoiceState, RootState> = {
  namespaced: true,
  state: () => state,
  actions: {
    // Les appelants transmettent toujours la facture complète (ligne de tableau) ou null.
    // Il n'existe pas d'endpoint de lecture d'une facture par id : l'ancien chemin par id
    // appelait /invoices/:id, qui est la route de GÉNÉRATION et crée une facture pour la
    // commande portant cet identifiant.
    setInvoice: ({ commit }, invoice: Invoice | null): void => {
      commit('invoice', invoice);
    },
    clearInvoice: ({ dispatch }): Promise<void> => {
      return dispatch('setInvoice', null);
    },
    saveInvoice: ({ commit, dispatch }, invoiceId: number): Promise<void> => {
      commit('downloadLoading', true);
      return invoicesService
        .downloadInvoice(invoiceId)
        .then(file => file && dispatch('file/saveBase64As', file, { root: true }))
        .catch(error => dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('downloadLoading', false));
    }
  },
  mutations: {
    invoice: (state, invoice: Invoice) => (state.invoice = invoice),
    invoiceLoading: (state, loading: boolean) => (state.invoiceLoading = loading),
    downloadLoading: (state, loading: boolean) => (state.downloadLoading = loading)
  }
};

export default options;
